// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5502":"3d67c451","6592":"b8de7e03","8443":"4638c62e","8944":"b8de7e03","9474":"043da932"}[chunkId] + ".chunk.css";
};